//Header color
export const HeaderColor = "#F1AD1D";

//Footer color
export const FooterColor = "#4B4B4C";

//Dropzone Background
export const DropzoneColor = "#f1f1f1";

//Green Success
export const SuccessColor = "#52C41A";

//Red Error
export const ErrorColor = "#FF4D4F";

//Blue Process
export const ProcessColor = "#1890FF";